/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
/* eslint-disable no-shadow */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
// import { updateStatus } from '../../../../../actions/shared/requisitions/RequisitionActions';
import view from '../../../../../assets/img/icons/view.png';
import CommonRequisitionDetail from '../../../shared/requisition/shared/CommonRequistionDetails';
import ViewReceipt from '../../../shared/requisition/shared/ViewReceipt';
import {
  ACCOUNTS,
  ADMIN,
  ADMIN_DEPARTMENT,
  CUSTOMER_SUPPORT,
  EXPRESS_WIFI,
  NEW_PRODUCTS,
  NOC,
  OPERATIONS,
  PROCUREMENT,
  RESEARCH_AND_DEVELOPMENT,
  SALES,
  TECHNICAL_SUPPORT,
} from '../../../../../utils/departments/helpers';
import { VICE_PRESIDENT_FSE } from '../../../../../utils/config';

class CeoAndCooRequisitionTableBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // requistionId: {},
      selectedRequisition: null,
      activeModal: null,
    };
  }

  // getRequsition(requisition) {
  //   this.setState({
  //     requistionId: requisition,
  //   });
  // }

  handleOpenModal = (requisition, modalType) => {
    this.setState({
      selectedRequisition: requisition,
      activeModal: modalType,
    });

    if (modalType === 'viewFile' && requisition.imageUpload) {
      const extension = requisition.imageUpload.split('.').pop();
      if (extension === 'document' || extension === 'pdf') {
        window.open(requisition.imageUpload, '_blank');
        return;
      }
    }
  };

  handleCloseModal = () => {
    this.setState({
      activeModal: null,
      selectedRequisition: null,
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // approveOrDisapprove = (req, id) => {
  //   const { updateStatus } = this.props;
  //   updateStatus(req, id);
  // };

  render() {
    const { requist, giveCeoCooApproval, giveCeoCooDisApproval } = this.props;

    const {selectedRequisition, activeModal } = this.state;

    const department = new Map([
      [`${ACCOUNTS}`, 'Accounts'],
      [`${ADMIN}`, 'ADMIN'],
      [`${ADMIN_DEPARTMENT}`, 'ADMIN_DEPARTMENT'],
      [`${CUSTOMER_SUPPORT}`, 'CUSTOMER SUPPORT'],
      [`${VICE_PRESIDENT_FSE}`, 'VICE PRESIDENT FSE'],
      [`${EXPRESS_WIFI}`, 'EXPRESS WIFI'],
      [`${NEW_PRODUCTS}`, 'NEW PRODUCTS'],
      [`${NOC}`, 'NOC'],
      [`${OPERATIONS}`, 'OPERATIONS'],
      [`${PROCUREMENT}`, 'PROCUREMENT'],
      [`${RESEARCH_AND_DEVELOPMENT}`, 'RESEARCH AND DEVELOPMENT'],
      [`${SALES}`, 'SALES'],
      [`${TECHNICAL_SUPPORT}`, 'TECHNICAL SUPPORT'],
    ]);

    const getDepartment = (type) => <strong>{department.get(type)}</strong> || null;

    const requsitionList = requist ? (
      requist.map((requsition, i) => {
        return (
          <tr>
            <td>{i + 1}</td>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            <td>N{requsition.amount_in_digits} </td>
            <td>{requsition.amount_in_words} </td>
            <td>{requsition ? `${requsition.EmployeeAuth.employees[0].email}` : null}</td>
            <td>{requsition.in_favour_of}</td>
            <td>{requsition.purpose}</td>

            <td>{getDepartment(requsition.department_id)}</td>
            {requsition.created_at ? <td>{moment(requsition.created_at).format('MM/DD/YYYY')}</td> : 'N/A'}
            <td>
                <button
                  onClick={() => this.handleOpenModal(requsition, 'viewReceipt')}
                  style={{
                    border: '0',
                    backgroundColor: 'white',
                  }}>
                  <span className="view2">
                    <img src={view} alt="view" title="View Reciept" />
                  </span>
                </button>
            </td>
            <td>
              <small onClick={() => giveCeoCooApproval(requsition.id)}>Approvehhh</small>
            </td>
            <td>
              <small onClick={() => giveCeoCooDisApproval(requsition.id)}>Reject</small>
            </td>
            <td>
                <button
                  onClick={() => this.handleOpenModal(requsition, 'viewDetails')}
                  style={{
                    border: '0',
                    backgroundColor: 'white',
                  }}
                >
                  <span className="view2">
                    <img src={view} alt="view" title="View Details" />
                  </span>
                </button>
            </td>
          </tr>
        );
      })
    ) : (
      <tr>
        <td colSpan="11">no requsitions</td>
      </tr>
    );

    return (
      <>
    <tbody>{requsitionList}</tbody>;
    {activeModal === 'viewReceipt' && (
          <div className="modal-root">
            <ViewReceipt 
              requisit={selectedRequisition} 
              onClose={this.handleCloseModal}
            />
          </div>
        )}
        
        {activeModal === 'viewDetails' && (
          <div className="modal-root">
            <CommonRequisitionDetail 
              requisit={selectedRequisition} 
              onClose={this.handleCloseModal}
            />
          </div>
        )}
        
        <ToastContainer />
    </>
    )
  }
}

// const mapStateToProps = (state) => ({
//   loading: state.requisitions.form,
// });

CeoAndCooRequisitionTableBody.propTypes = {
  // updateStatus: PropTypes.func,
  requist: PropTypes.shape(),
  giveCeoCooApproval: PropTypes.func,
  giveCeoCooDisApproval: PropTypes.func,
};
export default CeoAndCooRequisitionTableBody;
